import { useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { useLazyQuery } from '@apollo/client';
import GET_KEYBOARDING_MODULES from 'graph/resource/keyboarding-modules-query';
import useProductCache from 'store/cache/product-cache';
import { KeyboardingModule } from 'types/schema-generated-types';

const useAssessmentAcceleratorPreview = () => {
  const [{ findProductCurriculumByCode }] = useProductCache();
  const { resourceTypeId, productCurriculumCode } = useParams<{
    resourceTypeId: string;
    productCurriculumCode: string;
  }>();
  const [getKeyboardingModules, { data, loading, error }] = useLazyQuery<{
    keyboardingModules: KeyboardingModule[];
  }>(GET_KEYBOARDING_MODULES);

  const productCurriculum = findProductCurriculumByCode(productCurriculumCode);
  const gradeLevel = productCurriculum?.gradeLevel?.[0];

  useEffect(() => {
    if (!productCurriculum || !gradeLevel) return;

    getKeyboardingModules({
      variables: {
        where: { parentModuleId: null, productCurriculumId: productCurriculum.id }
      }
    });
  }, [getKeyboardingModules, productCurriculum, gradeLevel]);

  return {
    data,
    loading,
    error,
    gradeLevel,
    productCurriculumCode,
    resourceTypeId
  };
};

export default useAssessmentAcceleratorPreview;
